export const SLICE_NAME = 'onlineServices';